(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lngvty-coming-soon-product"] && !Shopify.designMode) return;
  try {
    
  class LngvtyComingSoonProduct extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.buttons = [...this.querySelectorAll('[data-flavor-button]')];
      this.images = [...this.querySelectorAll('[data-flavor-image]')];
      this.flavorLabel = this.querySelector('[data-selected-flavor]');
      this.flavorField = this.querySelector('[data-flavor-field]');
      this.signupForm = this.querySelector('[data-klaviyo-form]');
      this.emailInput = this.signupForm?.querySelector('input[type="email"]');
      this.submitButton = this.signupForm?.querySelector('button[type="submit"]');
      this.successMessage = this.signupForm?.querySelector('.lngvty-coming-soon-product__success');
      this.errorMessage = this.signupForm?.querySelector('.lngvty-coming-soon-product__errors');

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.selectFlavor(button));
      });

      this.signupForm?.addEventListener('submit', (event) => this.submitSignup(event));
    }

    selectFlavor(button) {
      const variantId = button.dataset.variantId;
      const flavor = button.dataset.flavor;

      this.style.setProperty('--flavor-primary', button.dataset.primary);
      this.style.setProperty('--flavor-secondary', button.dataset.secondary);
      this.style.setProperty('--flavor-soft', button.dataset.soft);

      this.buttons.forEach((item) => {
        const isActive = item === button;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      this.images.forEach((image) => {
        image.classList.toggle('is-active', image.dataset.flavorImage === variantId);
      });

      if (this.flavorLabel) this.flavorLabel.textContent = flavor;

      if (this.flavorField) this.flavorField.value = flavor;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    }

    async submitSignup(event) {
      event.preventDefault();

      const email = this.emailInput?.value.trim() || '';
      const siteId = this.dataset.klaviyoSiteId || '';
      const listId = this.dataset.klaviyoListId || '';
      const source = this.dataset.klaviyoSource || 'Coming Soon PDP';
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      this.setFormMessage(this.errorMessage, '', true);
      this.setFormMessage(this.successMessage, '', true);

      if (!emailPattern.test(email)) {
        this.setFormMessage(this.errorMessage, 'Please enter a valid email address.');
        this.emailInput?.focus();
        return;
      }

      if (!siteId || !listId) {
        this.setFormMessage(this.errorMessage, 'This signup form is not configured yet.');
        return;
      }

      this.setLoading(true);

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  properties: {
                    'Coming Soon Product': this.dataset.productTitle || '',
                    'Coming Soon Product Handle': this.dataset.productHandle || '',
                    'Selected Flavor': this.flavorField?.value || '',
                    'Signup Source': source
                  },
                  subscriptions: {
                    email: { marketing: { consent: 'SUBSCRIBED' } }
                  }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      };

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(siteId)}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              revision: '2025-10-15'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok && response.status !== 202) {
          throw new Error(`Klaviyo signup failed with status ${response.status}`);
        }

        this.emailInput.value = '';
        this.setFormMessage(
          this.successMessage,
          "You're on the list. We'll let you know when it launches."
        );
        this.setLoading(false);
      } catch (error) {
        this.setLoading(false);
        this.setFormMessage(this.errorMessage, 'Something went wrong. Please try again in a moment.');
        console.error('[LNGVTY+ coming-soon signup]', error);
      }
    }

    setLoading(isLoading) {
      if (!this.submitButton) return;
      this.submitButton.disabled = isLoading;
      const label = this.submitButton.querySelector('span');
      if (label) {
        label.textContent = isLoading
          ? this.submitButton.dataset.loadingLabel
          : this.submitButton.dataset.idleLabel;
      }
    }

    setFormMessage(element, message, hidden = false) {
      if (!element) return;
      element.textContent = message;
      element.hidden = hidden;
    }
  }

  if (!customElements.get('lngvty-coming-soon-product')) {
    customElements.define('lngvty-coming-soon-product', LngvtyComingSoonProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
